import { APP_URL } from '../config';

/**
 * Extracts the course ID from a course content path
 * @param {string} path - Course content path (e.g., "assets/coursedata/{id}/index.html")
 * @returns {string|null} - The course ID or null if not found
 */
export const extractCourseIdFromPath = (path) => {
    if (!path) return null;
    // Path format: assets/coursedata/{courseId}/...
    const parts = path.split('/');
    if (parts.length >= 3 && parts[0] === 'assets' && parts[1] === 'coursedata') {
        return parts[2]; // This is the course ID
    }
    return null;
};

/**
 * Gets the media URL for a course (image or gif)
 * @param {string} courseContentPath - The course content path
 * @param {boolean} isLmsCourse - Whether this is an LMS course
 * @param {string} mediaType - Either 'png' or 'gif'
 * @param {number} timestamp - Optional cache-busting timestamp
 * @returns {string|null} - The full media URL or null
 */
export const getCourseMediaUrl = (courseContentPath, isLmsCourse, mediaType, timestamp = null) => {
    if (!courseContentPath) return null;

    const courseId = extractCourseIdFromPath(courseContentPath);
    if (!courseId) return null;

    let mediaPath;
    if (isLmsCourse) {
        // LMS courses: images are at root of course directory
        mediaPath = `assets/course/${courseId}/card.${mediaType}`;
    } else {
        // Non-LMS courses: images are in the //tmp/TempStorage/{id}/ path
        mediaPath = `assets/coursedata/${courseId}//tmp/TempStorage/${courseId}/card.${mediaType}`;
    }

    const url = `${APP_URL}/${mediaPath}`;
    return timestamp ? `${url}?ts=${timestamp}` : url;
};

/**
 * Gets both image and gif URLs for a course
 * @param {string} courseContentPath - The course content path
 * @param {boolean} isLmsCourse - Whether this is an LMS course
 * @param {number} timestamp - Optional cache-busting timestamp
 * @returns {Object} - Object with imageUrl and gifUrl properties
 */
export const getCourseMediaUrls = (courseContentPath, isLmsCourse, timestamp = null) => {
    return {
        imageUrl: getCourseMediaUrl(courseContentPath, isLmsCourse, 'png', timestamp),
        gifUrl: getCourseMediaUrl(courseContentPath, isLmsCourse, 'gif', timestamp)
    };
};